import { render, staticRenderFns } from "./routeEdit.vue?vue&type=template&id=2413ba63&scoped=true&"
import script from "./routeEdit.vue?vue&type=script&lang=js&"
export * from "./routeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2413ba63",
  null
  
)

export default component.exports